import React, { useState } from "react";
import "../styles/OfferingsEnrollForm.css";

interface FormData {
  firstName: string;
  lastName: string;
  addressLine1: string;
  addressLine2: string;
  landmark: string;
  city: string;
  state: string;
  pincode: string;
  mobileNumber: string;
}

interface EnrollmentFormProps {
  onClose: () => void;
  courseTitle: string;
}

const EnrollmentForm: React.FC<EnrollmentFormProps> = ({
  onClose,
  courseTitle,
}) => {
  const [formData, setFormData] = useState<FormData>({
    firstName: "",
    lastName: "",
    addressLine1: "",
    addressLine2: "",
    landmark: "",
    city: "",
    state: "",
    pincode: "",
    mobileNumber: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission logic here
  
    onClose();
  };

  return (
    <div className="offerings-enrollment-popup">
      <div className="offerings-enrollment-popup-content">
        <div className="offerings-enrollment-popup-header">
          <div className="offerings-enrollment-popup-title-text">
            Enroll in {courseTitle}
          </div>
          <button className="offerings-close-button" onClick={onClose}>
            ×
          </button>
        </div>
        <p className="offerings-enrollment-description">
          As a part of program enrolment, we need your shipping address to ship
          the program kit. Please enter your shipping address.
        </p>

        <form
          onSubmit={handleSubmit}
          className="offerings-enrollment-form-container"
        >
          <div className="offerings-form-row">
            <div className="offerings-form-group">
              <label htmlFor="firstName">First Name*</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="offerings-form-group">
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="offerings-form-group">
            <label htmlFor="addressLine1">
              Flat, House no., Building, Company, Apartment*
            </label>
            <input
              type="text"
              id="addressLine1"
              name="addressLine1"
              value={formData.addressLine1}
              onChange={handleChange}
              required
            />
          </div>

          <div className="offerings-form-group">
            <label htmlFor="addressLine2">Area, Street, Sector, Village*</label>
            <input
              type="text"
              id="addressLine2"
              name="addressLine2"
              value={formData.addressLine2}
              onChange={handleChange}
              required
            />
          </div>

          <div className="offerings-form-group">
            <label htmlFor="landmark">Landmark</label>
            <input
              type="text"
              id="landmark"
              name="landmark"
              value={formData.landmark}
              onChange={handleChange}
            />
          </div>

          <div className="offerings-form-row">
            <div className="offerings-form-group">
              <label htmlFor="city">Town/City*</label>
              <input
                type="text"
                id="city"
                name="city"
                value={formData.city}
                onChange={handleChange}
                required
              />
            </div>
            <div className="offerings-form-group">
              <label htmlFor="state">State*</label>
              <input
                type="text"
                id="state"
                name="state"
                value={formData.state}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="offerings-form-row">
            <div className="offerings-form-group">
              <label htmlFor="pincode">Pincode</label>
              <input
                type="text"
                id="pincode"
                name="pincode"
                value={formData.pincode}
                onChange={handleChange}
              />
            </div>
            <div className="offerings-form-group">
              <label htmlFor="mobileNumber">Mobile Number*</label>
              <div className="offerings-mobile-input">
                <span className="offerings-country-code">(+91)</span>
                <input
                  type="tel"
                  id="mobileNumber"
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  required
                  pattern="[0-9]{10}"
                />
              </div>
            </div>
          </div>

          <button type="submit" className="offerings-submit-button">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default EnrollmentForm;
